import type { LocaleStrings } from "../types.ts";

export const ptLocale: LocaleStrings = {
  game: {
    defaultClanName: "O teu clã",
    clanSetupTitle: "Cria o teu clã",
    clanSetupNameLabel: "Nome do clã",
    clanSetupNamePlaceholder: "Introduz um nome",
    clanSetupConfirm: "Confirmar",
    settleConfirm: "Continuar",
    promptConfirmStart: "Começar aqui?",
    startTileConfirm: "Confirmar",
    startTileCancel: "Cancelar",
    clanSetupTotemLabel: "Totem",
    promptClanSetup: "Dá um nome ao clã, escolhe um totem e confirma para escolher a casa inicial.",
    statsHeaderFormat: "{clanName} · {turnLabel} {turn}",
    promptSelectStart: "Escolhe onde o teu clã deve começar.",
    promptClanEstablished: "Clã estabelecido.",
    promptEndTurn: "Termina o turno quando estiveres pronto.",
    promptNewTurn: "Move-te para uma casa adjacente ou termina o turno.",
    promptVictory: "O teu clã prospera!",
    promptDefeat: "O teu clã está faminto.",
    tileContentsFormat: "{terrain} — {food} comida/turno",
    tileContentsReducedFormat: "{terrain} — {effective}/{base} comida/turno",
    tileTravelingFormat: "{terrain} — a viajar, sem colheita neste turno",
    turnLabel: "Turno",
    dayNightLabels: {
      day: "Dia",
      dusk: "Entardecer",
      night: "Noite",
      dawn: "Amanhecer",
    },
    seasonLabels: {
      spring: "Primavera",
      summer: "Verão",
      autumn: "Outono",
      winter: "Inverno",
    },
    temperatureFormat: "{value}°C",
    weatherLabels: {
      clear: "Limpo",
      cloudy: "Nublado",
      overcast: "Encoberto",
      rainy: "Chuva",
      snowy: "Neve",
    },
    populationLabel: "População",
    foodLabel: "Comida",
    waterLabel: "Água",
    ambientPredatorsLabel: "Predadores",
    ambientPredatorLevelLabels: {
      none: "Nenhum",
      low: "Baixo",
      medium: "Médio",
      high: "Alto",
    },
    populationProgressFormat: "{current} / {max}",
    foodGrowthHintFormat: "→ crescimento em {threshold}",
    statsCollapsedChipFormat: "Turno {turn} · {population} · {food} · {water} · {predators}",
    endTurnLabel: "Terminar turno",
    terrainNames: {
      ["desert"]: "Deserto",
      ["mountain"]: "Montanha",
      ["swamp"]: "Pântano",
      ["forest"]: "Floresta",
      ["plains"]: "Planície",
      ["river"]: "Rio",
    },
    totemNames: {
      carved: "Entalhado",
      antler: "Chifres",
      spiral: "Espiral",
    },
    victoryTitle: "Vitória!",
    victoryMessage: "O teu clã chegou a 30 pessoas. Uma verdadeira civilização começa.",
    victoryRecapLineFormat: "{label}: {value}",
    victoryRecapTurns: "Turnos até à vitória",
    victoryRecapPopulation: "População",
    victoryRecapFood: "Comida",
    victoryRecapStartTerrain: "Terreno inicial",
    victoryRecapEndTerrain: "Terreno final",
    victoryRecapExplored: "Mapa explorado",
    victoryRecapExploredFormat: "{explored} / {total} casas",
    defeatTitle: "Derrota",
    defeatMessage: "Os últimos do teu povo desapareceram.",
    startAgain: "Começar de novo",
    resetLabel: "Repor",
    exitGame: "Sair do jogo",
    settingsTitle: "Definições",
    settingsCloseAriaLabel: "Fechar definições",
    languageLabel: "Idioma",
    sfxVolumeLabel: "Efeitos sonoros — {level}",
    debugModeOff: "Modo de depuração desativado",
    debugModeOn: "Modo de depuração ativado",
    fullscreenOff: "Ecrã inteiro desativado",
    fullscreenOn: "Ecrã inteiro ativado",
    foodOverlayOff: "Mostrar comida no mapa",
    foodOverlayOn: "Ocultar comida no mapa",
    waterOverlayOff: "Mostrar água no mapa",
    waterOverlayOn: "Ocultar água no mapa",
    promptBannerHide: "Ocultar banner de instruções",
    promptBannerShow: "Mostrar banner de instruções",
    stagingBadgeLabel: "Staging",
    hudSettingsTooltip: "Abrir definições",
    hudNotificationsTooltip: "Abrir notificações",
    notificationMarkDone: "Marcar como concluída",
    notificationOk: "OK",
    notificationCancel: "Cancelar",
    closeAriaLabel: "Fechar",
    leaveConfirmTitle: "Guardar e sair?",
    leaveConfirmBody:
      "O teu progresso será guardado. Podes continuar esta partida a partir do ecrã inicial.",
    leaveConfirmSave: "Guardar e sair",
    leaveConfirmStay: "Ficar no jogo",
    leaveConfirmSaveFailed:
      "Não foi possível guardar o jogo. Liberte espaço no navegador e tente novamente.",
    notificationEmpty: "Sem notificações neste momento.",
    notificationPageOf: "{current} / {total}",
    notificationPageIndicatorOf: "({current} / {total})",
    notificationSwampTitle: "Pântano",
    notificationSwampBody: "O teu clã entrou num pântano. O chão está encharcado e avançar aqui é mais difícil.",
    notificationFireTitle: "Fogo descoberto",
    notificationFireBody:
      "O teu clã encontrou fogo nesta casa—uma descoberta rara ao explorar o mapa.",
    notificationFoodDepletionTitle: "Terra esgotada",
    notificationFoodDepletionBody:
      "Ficar no mesmo hexágono reduz a comida que produz. Move-te e deixa a terra recuperar com o tempo.",
    notificationTutorialTurnsTitle: "O teu primeiro turno",
    notificationTutorialTurnsBody:
      "Move-te para uma casa adjacente, ou termina o turno quando estiveres pronto.",
    notificationTutorialStatsTitle: "Estatísticas do clã",
    notificationTutorialStatsBody:
      "O painel no canto superior esquerdo mostra turno, hora do dia, estação, temperatura, clima, população, comida, água e predadores no teu mosaico. Prima E ou Terminar turno quando estiveres pronto para recolher e avançar.",
    notificationTutorialWinGoalTitle: "Como vencer",
    notificationTutorialWinGoalBody:
      "Faz crescer o clã até 30 pessoas para vencer. Se a população cair a zero, o clã está perdido.",
    notificationTutorialFoodEconomyTitle: "Comida a cada turno",
    notificationTutorialFoodEconomyBody:
      "Quando terminas o turno, a casa produz comida. A população come primeiro—o resto soma ou subtrai das reservas.",
    notificationTutorialTileFoodTitle: "Ler uma casa",
    notificationTutorialTileFoodBody:
      "Cada casa revelada mostra terreno e comida por turno. Explora antes de te instalares—terrenos férteis como planícies e rios alimentam por mais tempo.",
    notificationTutorialGrowthTitle: "Crescimento",
    notificationTutorialGrowthBody:
      "Quando as reservas se mantêm altas vários turnos seguidos, a população cresce em um.",
    notificationTutorialFamineTitle: "Fome",
    notificationTutorialFamineBody:
      "Se o clã passa fome demasiado tempo, perdes uma pessoa. Move-te para casas férteis e acumula reservas.",
    notificationTutorialOneMoveTitle: "Mover a cada turno",
    notificationTutorialOneMoveBody:
      "Prima 1–6 ou clica numa casa adjacente destacada por turno, ou fica parado. Ficar demasiado tempo esgota a terra.",
    notificationTutorialFoodOverlayTitle: "Comida no mapa",
    notificationTutorialFoodOverlayBody:
      "Prima F ou usa o botão do grão no HUD para mostrar comida nas casas reveladas sem abrir cada uma.",
    notificationTutorialLandRecoveryTitle: "A terra recupera",
    notificationTutorialLandRecoveryBody:
      "As casas que deixas recuperam comida com o tempo. Continua a mover-te para não esgotar um só sítio.",
    notificationTutorialSettingsTitle: "Definições",
    notificationTutorialSettingsBody:
      "Prima S ou abre a roda dentada para mudar idioma, ajustar efeitos sonoros, alternar ecrã inteiro, recomeçar ou voltar ao ecrã inicial.",
    notificationTutorialRandomEventsTitle: "Eventos no mapa",
    notificationTutorialRandomEventsBody:
      "Podem aparecer eventos inesperados ao explorar. Prima N ou abre o sino para ler o que aconteceu.",
    languageLabels: {
      en: "Inglês",
      it: "Italiano",
      fr: "Francês",
      es: "Espanhol",
      pt: "Português",
      de: "Alemão",
      zh: "Chinês",
      nl: "Neerlandês",
    },
  },
  site: {
    gameTitle: "Dawn of Clans",
    kofiButtonLabel: "Apoia-me no Ko-fi",
    discordLinkLabel: "Entrar no Discord",
    landing: {
      primaryDescription:
        "Dawn of Clans é um jogo de grande estratégia em que guias um clã pré-histórico pela sobrevivência, descoberta e evolução social.",
      secondaryDescription:
        "Começando com um pequeno grupo nómada, desbloquearás tecnologias com a experiência, adaptarás a ambientes em mudança e moldarás o surgimento das primeiras civilizações.",
      earlyAccessLabel: "Acesso antecipado",
      earlyAccessNotice:
        "Em desenvolvimento inicial. O ciclo de sobrevivência básico é jogável hoje; sistemas estratégicos mais profundos estão a caminho.",
      learnMoreLabel: "Saber mais",
      releaseNoticeText: "Acabou de sair uma nova versão!",
      playLabel: "Jogar",
      continueLabel: "Continuar",
      savedGameSummary: "Turno {turn}, População {population}",
      resumeModalTitle: "Jogo guardado",
      newGameLabel: "Novo jogo",
      loadingLabel: "A carregar...",
      changelogLink: "Novidades",
      careerTeaserFormat:
        "{wins} vitórias · recorde: {fastest} turnos · mais explorado: {explored}",
      careerViewChronicleLabel: "Ver crónica de vitórias",
      chronicleModalTitle: "Crónica de vitórias",
      chronicleModalCloseLabel: "Fechar",
      chronicleEntryFormat: "{clanName} · {turns} turnos · {date}",
      chronicleClearWinHistoryLabel: "Limpar histórico de vitórias",
      chronicleClearWinHistoryBody:
        "Remove todas as vitórias guardadas neste dispositivo. O jogo em curso não é afetado.",
      chronicleClearWinHistoryConfirm: "Sim, limpar histórico",
      chronicleClearWinHistoryCancel: "Cancelar",
      settingsGearAriaLabel: "Definições",
      settingsCloseAriaLabel: "Fechar definições",
    },
    about: {
      pageTitle: "Sobre Dawn of Clans",
      backLinkLabel: "← Voltar a Dawn of Clans",
      sections: [
        {
          heading: "Visão geral",
          body: "Dawn of Clans é um jogo de grande estratégia em que guias um clã pré-histórico pela sobrevivência, descoberta e evolução social. Começando com um pequeno grupo nómada, desbloquearás tecnologias com a experiência, adaptarás a ambientes em mudança e moldarás o surgimento das primeiras civilizações.",
        },
        {
          heading: "O teu clã",
          body: "No início de uma nova partida, dá um nome ao teu clã e escolhe onde te instalar no mapa hexagonal. Depois de fundar o primeiro assentamento, acompanha turno, população e comida no painel de estatísticas. Termina cada turno para alimentar o clã e decide se moves para uma casa adjacente antes do próximo turno.",
        },
        {
          heading: "Progressão",
          body: "Cada terreno produz uma quantidade diferente de comida por turno. Quando as reservas de comida se mantêm altas vários turnos seguidos, a população cresce; se o clã fica faminto por muito tempo, perdes pessoas. Acumula reservas em terrenos férteis como rios e planícies, depois faz crescer o clã até trinta pessoas para vencer. Se a população chega a zero, o clã desaparece.",
        },
        {
          heading: "O mundo",
          body: "Explora um mapa hexagonal onde as casas começam ocultas. Clica para revelar deserto, montanha, pântano, floresta, planície e rio. Escolhe onde estabelecer o primeiro assentamento e depois move uma casa adjacente por turno. Terras férteis alimentam mais bocas; terras hostis esgotam as reservas rapidamente.",
        },
        {
          heading: "Estado",
          body: "Dawn of Clans está em desenvolvimento inicial. Exploração, assentamento, comida e população por turnos, e vitória ou derrota são jogáveis hoje. Sistemas estratégicos mais profundos ainda estão em construção.",
        },
      ],
      communitySection: {
        heading: "Comunidade",
        body: "Conversa com outros jogadores, partilha feedback e segue as novidades do desenvolvimento no nosso servidor Discord.",
      },
      supportSection: {
        heading: "Apoia o projeto",
        body: "Gostas de Dawn of Clans? Donativos opcionais no Ko-fi ajudam a financiar o desenvolvimento.",
      },
    },
    changelog: {
      pageTitle: "Novidades",
      backLinkLabel: "← Voltar a Dawn of Clans",
      loadError: "Não foi possível carregar as novidades.",
      emptyState: "Ainda não há versões publicadas.",
    },
  },
};
